import { Divider, Typography } from '@mui/material'
import { Box } from '@mui/system'
import AdxDrawerComponent from 'components/reusable/drawer/AdxDrawerComponent'
import React from 'react'
import PTMDrawerBody from './PTMDrawerBody'

const PTMDrawer = ({ drawerState, handleDrawer, staff, appraisalId }) => {
  return (
    <Box>
      <AdxDrawerComponent
        state={drawerState}
        anchor="right"
        onClose={handleDrawer}
        headerprops
        title={'Participant Result'}
        noPaddingContent
      >
        <Divider />
        <PTMDrawerBody staff={staff} appraisalId={appraisalId} />
      </AdxDrawerComponent>
    </Box>
  )
}

export default PTMDrawer
